export const convertStringToArray = (
  value: string | string[] | number,
): string[] => (typeof value === 'object' ? value : [value.toString()]);

export const reverseSortOrder = (
  sortOrder: Nl.QueryFilterSortOrderType,
): Nl.QueryFilterSortOrderType => (sortOrder === 'asc' ? 'desc' : 'asc');
